// FILECONTENT_START src/common/components/PageHeader/PageHeader.tsx
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import {
  IconButton,
  Skeleton,
  Toolbar,
  ToolbarProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useThemeProps } from "./../../modules/theme";
import { useNavigationContext } from "./../Navigation";
import Spacer from "./../Spacer";

export interface PageHeaderProps extends ToolbarProps {
  title?: string;
  subtitle?: string | ReactNode;
  loading?: boolean;
  backUrl?: string;
  rightContent?: ReactNode;
  leftContent?: ReactNode;
  avatar?: ReactNode;
  titleProps?: TypographyProps;
  subtitleProps?: TypographyProps;
  onClose?: Function;
  wrap?: any;
  modal?: boolean;
}
export default function PageHeader(_props: PageHeaderProps) {
  const navigate = useNavigate();
  const {
    loading,
    title,
    subtitle,
    backUrl,
    rightContent,
    leftContent,
    children,
    avatar,
    titleProps,
    subtitleProps,
    onClose,
    wrap,
    sx: baseSx,
    ...rest
  } = useThemeProps<PageHeaderProps>(_props, "MuiPageHeader");

  const { prevLocation } = useNavigationContext();

  const canGoBack = !!prevLocation;

  let sx: any = {
    //borderBottom: 1,
    //borderTop: 1,
    //borderColor: "divider",
    //marginLeft: -3,
    //marginRight: -3,
    ...baseSx,
  };

  if (onClose) {
    sx.padding = (theme: any) => `${theme.spacing(2)} ${theme.spacing(3)}`;
    sx.minHeight = 0;
  } else {
    sx.marginLeft = backUrl ? -3 : 0;
    //sx.marginRight = -3;
  }

  return (
    <Toolbar className="MuiPageHeader" disableGutters sx={sx} {...rest}>
      {!!backUrl && canGoBack && (
        <IconButton
          onClick={(evt: any) => {
            evt.stopPropagation();
            navigate(-1);
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}
      {!!backUrl && !canGoBack && (
        <IconButton
          //@ts-ignore
          component={Link}
          to={backUrl}
          onClick={(evt: any) => {
            evt.preventDefault();
            evt.stopPropagation();
            navigate(-1);
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}

      {avatar}
      {!!avatar && <Spacer w={2} />}
      <div style={wrap}>
        {(!!title || loading) &&
          (loading ? (
            <Skeleton variant="text" sx={{ minWidth: 200, minHeight: 36 }} />
          ) : (
            <Typography variant="h5" {...titleProps}>
              {title}
            </Typography>
          ))}
        {(!!subtitle || loading) &&
          (loading ? (
            <Skeleton variant="text" sx={{ minWidth: 140, minHeight: 24 }} />
          ) : typeof subtitle === "string" ? (
            <Typography variant="body1" color="GrayText" {...subtitleProps}>
              {subtitle}
            </Typography>
          ) : (
            subtitle
          ))}
      </div>
      {!!leftContent && (
        <>
          <Spacer w={2} />
          {leftContent}
          <Spacer w={2} />
        </>
      )}
      {!!rightContent && (
        <>
          <Spacer right />
          {rightContent}
        </>
      )}
      {!!children && (
        <>
          <Spacer right />
          {children}
        </>
      )}
      {!!onClose && !rightContent && !children && <Spacer right />}
      {!!onClose && (
        <IconButton
          onClick={(evt: any) => {
            evt.stopPropagation();
            onClose && onClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Toolbar>
  );
}

// FILECONTENT_END src/common/components/PageHeader/PageHeader.tsx
